import React from 'react'
import UserProfile from './UserProfile'
import Header from 'components/VerticalLayout/Header'
import bgImage from "../../../assets/images/bgImage1.jpg";
import { Col, Container, Row } from 'reactstrap';
import DisplayCredits from './DisplayCredits';
import ProductWiseCreditUsage from './ProductWiseCreditUsage';
import RecentTransactionTable from './RecentTransactionTable';
import Notifications from './Notifications';

const UserCreditDashboard = () => {

    const userData = JSON.parse(localStorage.getItem("userData"));
    const user = userData.user;

  return (
    <div className='account=-pages'>
        <Header/>
        <div className='accountbg'
            style={{
            background: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment:"fixed",
            paddingTop:"80px",
            minHeight:"100vh",
            overflow:"auto",
            paddingLeft:"8px"
            }}
        >
        <Container fluid>
            <Row>
              <Col md={4}>
                <UserProfile user={user}/>
              </Col>
              <Col md={8}>
                <DisplayCredits/>
              </Col>
            </Row>

            <Row>
                <ProductWiseCreditUsage/>
            </Row>

            <Row>
              <Col>
                <RecentTransactionTable/>
              </Col>
              <Col>
                <Notifications/>
              </Col>
            </Row>
          </Container>
        </div>
    </div>
  )
}

export default UserCreditDashboard
